import { style } from '@vtex/admin-ui-core'

export const popoverStyle = style({
  bg: '$primary',
  boxShadow: '$overlay.center',
  border: '$neutral',
  borderRadius: '$default',
})
